/**
 * @typedef ImageCandidate
 * @type {[number, string]}
 */

/**
 * Converts a list of image candidates to a srcset string for use in the `<img>` elements `srcset` attribute
 * @param {ImageCandidate[]} imageCandidates
 * @return {string}
 */
function toSrcsetString(imageCandidates = []) {
  return imageCandidates?.map(([width, url]) => `${url} ${width}w`).join(',') ?? ''
}

module.exports = { toSrcsetString }
